export function isElementShown(element: HTMLElement | null): boolean {
  if (!element) {
    return false;
  }

  const elementPositionMiddle = element.offsetTop + element.offsetHeight / 2;
  const windowScrollPosition = window.pageYOffset + window.innerHeight;

  return windowScrollPosition > elementPositionMiddle;
}
